<template>
<div class="chapter">
<div class="inner_page">
<div class="parttitle"><span><a id="page1"></a><a href="#/contents#rp1" id="p1"><span style="color:#000000;"><b>Starting Premises</b></span></a></span></div>
<div class="image1"><span><img alt="image" src="images/common.png"/></span></div>
<div class="partnum"><span><a href="#/contents#rp1"><span style="color:#000000;"><b>I</b></span></a></span></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part1.vue?45e45036